import React, { useEffect, useRef, useState } from "react";
import styles from "./PokemonReveal.module.scss";

const POKEMONS = [
  "bulbasaur","squirtle","charmander","chikorita","totodile",
  "cyndaquil","pikachu","eevee",
  "celebi","mew","mewtwo","charizard"
];
const SPRITE_BASE =
  "https://img.pokemondb.net/sprites/black-white/anim/normal/";

export default function PokemonReveal({ pokemon = null }) {
  const [poke, setPoke] = useState(pokemon || "pikachu");
  const [flip, setFlip] = useState(false);
  const [isExiting, setIsExiting] = useState(false);
  const timer = useRef(null);
  const pkmnRef = useRef(null);

  // pick a new pokemon & trigger throw
  const chooseOne = () => {
    if (pokemon) return; // static mode, no cycling

    setFlip(f => !f);
    setPoke(POKEMONS[Math.floor(Math.random() * POKEMONS.length)]);
    setIsExiting(true);
  };

  // auto-cycle every 9s (disabled if static pokemon supplied)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (pokemon) return;
    timer.current = setTimeout(chooseOne, 9000);
    return () => clearTimeout(timer.current);
  }, [flip, pokemon]);

  // when the exit animation ends, clear the exit flag
  useEffect(() => {
    if (!pkmnRef.current) return;
    const el = pkmnRef.current;
    const onAnimEnd = e => {
      if (e.animationName === "explode-filters" || e.animationName === "throw") {
        setIsExiting(false);
      }
    };
    el.addEventListener("animationend", onAnimEnd);
    return () => el.removeEventListener("animationend", onAnimEnd);
  }, []);

  // inline var for sprite URL
  const cssVars = { "--poke1": `url(${SPRITE_BASE}${poke}.gif)` };

  return (
    <div
      className={styles.revealWrapper}
      style={{ pointerEvents: pokemon ? "none" : "auto", margin: "0 auto" }}
      onClick={!pokemon ? chooseOne : undefined}
    >
      <div
        ref={pkmnRef}
        className={[
          styles.pkmn,
          isExiting && styles.exit,
          flip ? styles.right : styles.left
        ].filter(Boolean).join(" ")}
        style={{ ...cssVars, left: pokemon ? "50%" : undefined, transform: pokemon ? "translateX(-50%)" : undefined }}
      >
        {!pokemon && (
        <div
          className={[
            styles.poke,
            styles.ball,
            isExiting ? styles.throw : styles.bounce,
          ].join(" ")}
        >
          <span className={styles.x}>
            <span className={styles.y}>
              <span className={styles.sprite} />
            </span>
          </span>
        </div>
)}
        <div className={styles.mon} />
        <div className={styles.explode} />
      </div>
    </div>
  );
}
